import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { cn } from '../../../lib/utils';

interface NavigationButtonProps {
  displayText: string;
  navigationPath: string;
  icon?: string;
  disabled?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({
  displayText,
  navigationPath,
  disabled = false,
  isLoading = false,
  onClick,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    // Validate path before navigating
    if (navigationPath.startsWith('/')) {
      navigate(navigationPath);
    } else {
      console.warn(`Invalid navigation path: ${navigationPath}`);
    }
  };

  return (
    <Button
      onClick={handleClick}
      disabled={disabled || isLoading}
      variant="outline"
      size="sm"
      className={cn(
        'rounded-xl text-xs min-h-[32px]',
        'border-foreground/20 text-foreground/90',
        'hover:border-foreground/40 hover:bg-foreground/5',
        'disabled:border-foreground/10 disabled:text-foreground/30',
      )}
    >
      {isLoading ? 'Processing...' : displayText}
    </Button>
  );
};

export default NavigationButton;
